'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_EitherSample$package$$anon$1$$anon$3(evaluator$7) {
  this.KW = null;
  this.KW = evaluator$7;
}
export { $c_Lsamples_EitherSample$package$$anon$1$$anon$3 as $c_Lsamples_EitherSample$package$$anon$1$$anon$3 };
$p = $c_Lsamples_EitherSample$package$$anon$1$$anon$3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EitherSample$package$$anon$1$$anon$3;
/** @constructor */
function $h_Lsamples_EitherSample$package$$anon$1$$anon$3() {
}
export { $h_Lsamples_EitherSample$package$$anon$1$$anon$3 as $h_Lsamples_EitherSample$package$$anon$1$$anon$3 };
$h_Lsamples_EitherSample$package$$anon$1$$anon$3.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.KW.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EitherSample$package$$anon$1$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EitherSample$package$$anon$1$$anon$3, "samples.EitherSample$package$$anon$1$$anon$3", ({
  oC: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EitherSample$package$$anon$1$$anon$3 as $d_Lsamples_EitherSample$package$$anon$1$$anon$3 };
